export default __webpack_public_path__ + "static/media/player_4.8aaa6dca.png";